import { z } from 'zod';
import { DateTime } from 'luxon';

export enum EventType {
  CALL = 'call',
  VISIT = 'visit',
}

const today = DateTime.now().startOf('day');

export const IAttachToEventFormSchema = z
  .object({
    useExisting: z.boolean(),
    date: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format')
      .refine(
        val => {
          const parsedDate = DateTime.fromFormat(val, 'yyyy-MM-dd');
          return parsedDate >= today;
        },
        { message: 'The date must be today or in the future' }
      )
      .optional(),
    time: z.number().optional(),
    eventType: z.nativeEnum(EventType).optional(),
    existingEventId: z.number().nullable().optional(),
    existingEventNote: z.string().optional(),
    notes: z
      .string()
      .min(50, { message: 'Note must be atleast 50 characters' })
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.useExisting) {
      const requiredFields: { field: keyof typeof data; message: string }[] = [
        { field: 'date', message: 'Date is required' },
        { field: 'time', message: 'Time is required' },
        { field: 'eventType', message: 'Event type is required' },
        { field: 'notes', message: 'Notes is required' },
      ];
      requiredFields.forEach(({ field, message }) => {
        if (!data[field]) {
          ctx.addIssue({
            path: [field],
            message,
            code: 'custom',
          });
        }
      });
    }
  });

export type IAttachToEventForm = z.infer<typeof IAttachToEventFormSchema>;
